import { SearchTerm } from './SearchTerm';

const StillOnSiteSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all"
    },
    {
        heading: "Display Name",
        accessor: "name",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "mstTitle",
        translationKey: "title"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Middle Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix"
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "tags.tagCode",
        translationKey: "cardNumber"
    },
    {
        heading: "Custom Field",
        accessor: "customField",
        searchOnName: "masterDetails.mdValString",
        translationKey: "customField"
    }
];

export default StillOnSiteSearch;
